export class ScrollbarGeometry {
    public x: number;
    public y: number;

    public w: number;
    public h: number;

    constructor(x: number, y: number, w: number, h: number) {
        this.x = x;
        this.y = y;
        this.w = w;
        this.h = h;
    }
}

type ScrollPositionValue = number | 'start' | 'end';

export class ScrollbarPosition {
    public x: ScrollPositionValue;
    public y: ScrollPositionValue;

    constructor(x: ScrollPositionValue, y: ScrollPositionValue) {
        this.x = x;
        this.y = y;
    }
}
